const HowItWorks = () => {
  return (
    <section className="w-full py-16 bg-muted/30" id="how-it-works">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          How NameBioLab Works
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Generate perfect usernames and bios in just three simple steps
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center space-y-4 animate-fade-in">
            <div className="w-16 h-16 mx-auto bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-2xl font-bold">
              1
            </div>
            <h3 className="text-xl font-semibold">Enter Your Keywords</h3>
            <p className="text-muted-foreground">
              Type in words that describe you, your brand, or your interests. Be creative and specific!
            </p>
          </div>

          <div className="text-center space-y-4 animate-fade-in [animation-delay:0.1s]">
            <div className="w-16 h-16 mx-auto bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-2xl font-bold">
              2
            </div>
            <h3 className="text-xl font-semibold">Choose Your Style</h3>
            <p className="text-muted-foreground">
              Select what to generate and pick a theme: funny, cool, aesthetic, or professional.
            </p>
          </div>

          <div className="text-center space-y-4 animate-fade-in [animation-delay:0.2s]">
            <div className="w-16 h-16 mx-auto bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-2xl font-bold">
              3
            </div>
            <h3 className="text-xl font-semibold">Get Instant Results</h3>
            <p className="text-muted-foreground">
              Our AI generates 5 unique usernames and 5 catchy bios instantly. Copy and use anywhere!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
